import React from "react";

const User = ({ width = 42 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} viewBox="0 0 42 42">
    <path d="M35.849,27.151a20.919,20.919,0,0,0-7.98-5.005,12.141,12.141,0,1,0-13.738,0A21.033,21.033,0,0,0,0,42H3.281a17.719,17.719,0,0,1,35.438,0H42A20.863,20.863,0,0,0,35.849,27.151ZM21,21a8.859,8.859,0,1,1,8.859-8.859A8.869,8.869,0,0,1,21,21Z" />
  </svg>
);

export default User;
